import React, { useEffect } from 'react';
import './ImageViewerApp.css';
import ImageViewerComponent from '../pdfviewer/ImageViewerComponent';
import Navbar2DarkBg from '../interface/navbar/Navbar2DarkBg';
import SEO from '../SEO/SEO';

function ImageViewerApp({ setFolderName, sePurchaseLink, setThumbnail, setArticle, setPageLimit, setIsLazyLoadEnabled, setIsAnimated }) {

  // Definisikan string aslinya
  const originalString = setFolderName;

  // Lakukan penggantian langsung dan simpan hasilnya di variabel baru
  // Regex /[-_]/g akan mencari karakter '-' ATAU '_' secara global
  const modifiedString = originalString.replace(/[-_]/g, ' ');

  // Data artikel (bisa dari state atau props)
  const artikel = {
    judul: `${modifiedString}`,
    deskripsi: {modifiedString},
    url: `https://rekanata.com/${setFolderName}`,
    // Gunakan path relatif dari folder public
    gambarThumbnailLokal: `../assets/documents/jpg/ebooks/2025/${setFolderName}/${setThumbnail}`, 
    isi: {setArticle}
  };

  return (
    <div className="image-viewer-app-container" id='id-image-viewer-app-container'>
      
      <SEO
        title={artikel.judul}
        description={artikel.deskripsi}
        canonical={artikel.url}
        // Teruskan path lokal ke prop ogImage
        ogImage={artikel.gambarThumbnailLokal} 
        twitterImage={artikel.gambarThumbnailLokal}
        type="article" 
      />

      <Navbar2DarkBg />

      <div>
        <ImageViewerComponent
          folderName={setFolderName}
          pageLimit={10}
          isLazyLoadEnabled={false}
          isAnimated={true}
          openPurchaseLink={sePurchaseLink} />
      </div>
    </div>
  );
}

export default ImageViewerApp;

{/** 
  import React, { useEffect } from 'react';
import './ImageViewerApp.css';
import ImageViewerComponent from '../pdfviewer/ImageViewerComponent';
import Navbar2DarkBg from '../interface/navbar/Navbar2DarkBg';
import SEO from '../SEO/SEO';

function ImageViewerApp({ setFolderName, sePurchaseLink, setPageLimit, setThumbnail, setArticle, setIsLazyLoadEnabled, setIsAnimated }) {

  // Definisikan string aslinya
  const originalString = setFolderName;

  // Lakukan penggantian langsung dan simpan hasilnya di variabel baru
  // Regex /[-_]/g akan mencari karakter '-' ATAU '_' secara global
  const modifiedString = originalString.replace(/[-_]/g, ' ');

  // Data artikel (bisa dari state atau props)
  const artikel = {
    judul: {modifiedString},
    deskripsi: {modifiedString},
    url: `https://rekanata.com/${setFolderName}`,
    // Gunakan path relatif dari folder public
    gambarThumbnailLokal: `../assets/documents/jpg/ebooks/2025/${setFolderName}/${setThumbnail}`, 
    isi: {setArticle}
  };

  return (
    <div className="image-viewer-app-container" id='id-image-viewer-app-container'>
      <SEO
        title={artikel.judul}
        description={artikel.deskripsi}
        canonical={artikel.url}
        // Teruskan path lokal ke prop ogImage
        ogImage={artikel.gambarThumbnailLokal} 
        twitterImage={artikel.gambarThumbnailLokal}
        type="article" 
      />

      <Navbar2DarkBg />

      <div>
        <ImageViewerComponent
          folderName={setFolderName}
          pageLimit={10}
          isLazyLoadEnabled={false}
          isAnimated={true}
          openPurchaseLink={sePurchaseLink} />
      </div>
    </div>
  );
}

export default ImageViewerApp; */}